import React from 'react';

const PasswordChangeModal = ({
  show,
  passwordData,
  setPasswordData,
  handlePasswordChange,
  onClose,
  t,
  currentLanguage
}) => {
  if (!show) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h3 style={titleStyle}>{t('changePassword', {}, currentLanguage)}</h3>

        <form onSubmit={handlePasswordChange}>
          <InputField
            label={t('currentPassword', {}, currentLanguage)}
            type="password"
            value={passwordData.currentPassword}
            onChange={(e) => setPasswordData({ ...passwordData, currentPassword: e.target.value })}
            required
          />

          <InputField
            label={t('newPassword', {}, currentLanguage)}
            type="password"
            value={passwordData.newPassword}
            onChange={(e) => setPasswordData({ ...passwordData, newPassword: e.target.value })}
            required
            minLength={6}
          />

          <InputField
            label={t('confirmPassword', {}, currentLanguage)}
            type="password"
            value={passwordData.confirmPassword}
            onChange={(e) => setPasswordData({ ...passwordData, confirmPassword: e.target.value })}
            required
            minLength={6}
          />

          <div style={buttonRowStyle}>
            <button
              type="button"
              onClick={() => {
                onClose();
                setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
              }}
              style={cancelBtnStyle}
            >
              {t('cancel', {}, currentLanguage)}
            </button>

            <button type="submit" style={submitBtnStyle}>
              {t('changePassword', {}, currentLanguage)}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordChangeModal;

// --------------------------- Subcomponents & Styles ---------------------------

const InputField = ({ label, ...props }) => (
  <div style={{ marginBottom: '16px' }}>
    <label style={labelStyle}>{label}</label>
    <input style={inputStyle} {...props} />
  </div>
);

const overlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000
};

const modalStyle = {
  backgroundColor: 'white',
  padding: '24px',
  borderRadius: '12px',
  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
  maxWidth: '400px',
  width: '90%'
};

const titleStyle = {
  margin: '0 0 20px 0',
  fontSize: '18px',
  fontWeight: '600',
  color: '#1f2937'
};

const labelStyle = {
  display: 'block',
  fontSize: '14px',
  fontWeight: '500',
  color: '#374151',
  marginBottom: '6px'
};

const inputStyle = {
  width: '100%',
  padding: '8px 12px',
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  fontSize: '14px',
  boxSizing: 'border-box'
};

const buttonRowStyle = {
  display: 'flex',
  gap: '12px',
  justifyContent: 'flex-end'
};

const cancelBtnStyle = {
  padding: '8px 16px',
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  backgroundColor: 'white',
  color: '#374151',
  cursor: 'pointer',
  fontSize: '14px'
};

const submitBtnStyle = {
  padding: '8px 16px',
  border: 'none',
  borderRadius: '6px',
  backgroundColor: '#3b82f6',
  color: 'white',
  cursor: 'pointer',
  fontSize: '14px'
};
